import { useReducer, useCallback } from "react"
import { perfApiFetch } from "../../api/utils"

type DataFetchState = {
  loading: boolean
  error?: Error
  data?: JSON
}

type DataFetchAction = SuccessAction | ErrorAction | FetchAction

type FetchAction = {
  type: "FETCH"
}

type SuccessAction = {
  type: "SUCCESS"
  payload: JSON
}

type ErrorAction = {
  type: "ERROR"
  payload: Error
}

type DataAPIMethod = "POST" | "GET" | "PUT" | "DELETE"

const INITIAL_STATE: DataFetchState = {
  loading: false,
}

const dataFetchReducer = (
  state: DataFetchState,
  action: DataFetchAction
): DataFetchState => {
  switch (action.type) {
    case "FETCH":
      return {
        ...INITIAL_STATE,
        data: undefined,
        error: undefined,
        loading: true,
      }
    case "ERROR":
      return {
        ...state,
        error: action.payload,
        data: undefined,
        loading: false,
      }
    case "SUCCESS":
      return {
        ...state,
        data: action.payload,
        error: undefined,
        loading: false,
      }
  }
}

const httpMethods = ["POST", "PUT", "PATCH"]

/**
 * This hook has now been deprecated. See docs/apiFetching.md for more info.
 */
const useDataAPI = (url: string, method: DataAPIMethod) => {
  const [state, dispatch] = useReducer(dataFetchReducer, INITIAL_STATE)

  const fire = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (body?: any) => {
      dispatch({ type: "FETCH" })

      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = await perfApiFetch<any>(url, {
          method,
          body: httpMethods.includes(method) ? body : undefined,
          params: method === "GET" ? body : undefined,
        })
        dispatch({ type: "SUCCESS", payload: result.data })

        return result
      } catch (error) {
        if (error instanceof Error) {
          dispatch({ type: "ERROR", payload: error })
        }
        throw error
      }
    },
    [method, url]
  )

  return { ...state, fire }
}

export default useDataAPI
